import React, { useState } from 'react';
import { MapPin, ChevronDown, ChevronUp } from 'lucide-react';

interface CityFiltersProps {
  selectedCity: string | null;
  onSelectCity: (city: string | null) => void;
}

const CityFilters: React.FC<CityFiltersProps> = ({ selectedCity, onSelectCity }) => {
  const [showAllCities, setShowAllCities] = useState(false);
  
  // West Bengal cities
  const westBengalCities = [
    'Kolkata',
    'Darjeeling',
    'Siliguri',
    'Durgapur',
    'Asansol',
    'Howrah',
    'Kharagpur',
    'Jalpaiguri',
    'Haldia',
    'Malda'
  ];

  // Other major Indian cities
  const otherIndianCities = [
    'Ahmedabad',
    'Mumbai',
    'Pune',
    'Nagpur',
    'Delhi',
    'Gurugram', 
    'Noida',
    'Lucknow',
    'Varanasi',
    'Kanpur',
    'Jaipur',
    'Udaipur',
    'Jodhpur',
    'Bengaluru',
    'Mysuru',
    'Mangaluru',
    'Chennai',
    'Coimbatore',
    'Madurai',
    'Hyderabad',
    'Warangal',
    'Kochi',
    'Thiruvananthapuram',
    'Patna',
    'Gaya',
    'Ranchi',
    'Jamshedpur',
    'Bhubaneswar',
    'Cuttack',
    'Guwahati',
    'Shillong',
    'Imphal',
    'Aizawl',
    'Agartala',
    'Itanagar',
    'Panaji',
    'Chandigarh',
    'Srinagar',
    'Leh'
  ];

  // International cities and countries
  const internationalLocations = [
    // Asian Countries
    'Singapore',
    'China',
    'Hong Kong',
    'Malaysia',
    'Japan',
    'Bangladesh',
    
    // Middle East
    'Dubai',
    'UAE',
    
    // Europe
    'United Kingdom',
    'Germany',
    'Switzerland',
    'Poland',
    'Ireland',
    'Belgium',
    'Russia',
    
    // North America - USA (State wise)
    'Alabama, USA',
    'Alaska, USA',
    'Arizona, USA',
    'Arkansas, USA',
    'California, USA',
    'Colorado, USA',
    'Connecticut, USA',
    'Delaware, USA',
    'Florida, USA',
    'Georgia, USA',
    'Hawaii, USA',
    'Idaho, USA',
    'Illinois, USA',
    'Indiana, USA',
    'Iowa, USA',
    'Kansas, USA',
    'Kentucky, USA',
    'Louisiana, USA',
    'Maine, USA',
    'Maryland, USA',
    'Massachusetts, USA',
    'Michigan, USA',
    'Minnesota, USA',
    'Mississippi, USA',
    'Missouri, USA',
    'Montana, USA',
    'Nebraska, USA',
    'Nevada, USA',
    'New Hampshire, USA',
    'New Jersey, USA',
    'New Mexico, USA',
    'New York, USA',
    'North Carolina, USA',
    'North Dakota, USA',
    'Ohio, USA',
    'Oklahoma, USA',
    'Oregon, USA',
    'Pennsylvania, USA',
    'Rhode Island, USA',
    'South Carolina, USA',
    'South Dakota, USA',
    'Tennessee, USA',
    'Texas, USA',
    'Utah, USA',
    'Vermont, USA',
    'Virginia, USA',
    'Washington, USA',
    'West Virginia, USA',
    'Wisconsin, USA',
    'Wyoming, USA',
    'Canada',
    
    // South America
    'Colombia',
    'Brazil',
    
    // Oceania
    'Australia',
    
    // Africa
    'South Africa'
  ];

  // Decide which cities to show
  const initialCities = westBengalCities.slice(0, 6);
  const allCities = [...westBengalCities, ...otherIndianCities, ...internationalLocations];
  const citiesToShow = showAllCities ? allCities : initialCities;

  return (
    <div className="mb-8 text-center">
      <div className="flex items-center justify-center mb-5 relative">
        {selectedCity && (
          <button 
            onClick={() => onSelectCity(null)}
            className="text-sm text-dpn-pink hover:text-dpn-raspberry font-lucy-rose absolute right-0"
          >
            Clear Filter
          </button>
        )}
      </div>
      
      {/* City filters */}
      <div className="flex flex-wrap gap-3 mb-4 justify-center">
        {citiesToShow.map((city) => (
          <button
            key={city}
            onClick={() => onSelectCity(city === selectedCity ? null : city)}
            className={`px-5 py-2.5 rounded-full text-sm font-lucy-rose transition-all ${
              city === selectedCity
                ? 'bg-dpn-olive text-white shadow-md'
                : 'bg-dpn-light-green/80 hover:bg-dpn-light-green text-white'
            }`}
          >
            {city}
          </button>
        ))}
      </div>
      
      {/* Show More/Less Button */}
      <button
        onClick={() => setShowAllCities(!showAllCities)}
        className="flex items-center text-sm text-dpn-pink hover:text-dpn-raspberry font-lucy-rose mt-2 mx-auto"
      >
        {showAllCities ? (
          <>
            <ChevronUp className="h-4 w-4 mr-1" /> Show Less
          </>
        ) : (
          <>
            <ChevronDown className="h-4 w-4 mr-1" /> Show More Cities
          </>
        )}
      </button>
    </div>
  );
};

export default CityFilters;
